module.exports = __webpack_public_path__ + "img/Office_Depot.9aa8c9c3.svg";